import React from 'react'

import {
  presenceErrorClass,
  allowNumericOnly
} from 'servos/formValidations'

class StringInput extends React.Component {
  onChange = (e) => {
    this.props.onChange(e.currentTarget.value)
  }

  render() {
    const {
      placeholder,
      defaultValue,
      errorMessage,
      size,
      numberOnly
    } = this.props;

    const isNumberOnly = numberOnly ? allowNumericOnly : null;


    return(
      <div className="input-group">
        <input
          onKeyPress={isNumberOnly}
          defaultValue={ defaultValue }
          placeholder={ placeholder || '' }
          className={ `form-control ${classes.control[size]} ${presenceErrorClass(errorMessage)}` }
          onChange={ this.onChange }
        />
        <div className="invalid-feedback">
          { errorMessage }
        </div>
      </div>
    )
  }
}

const classes = {
  control: {
    large: 'form-control-lg',
  },
}

export default StringInput;
